/// <amd-module name="DRITools/Core/Components/DRIToolsZeroData" />
import * as React from "react";

// VSS
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";

// VSSUI
import { ZeroData } from "VSSUI/ZeroData";

// DRITools
import * as Resources from "DRITools/Core/Resources";

interface IDRIToolsZeroData {
    isInvalid: boolean;
}

export class DRIToolsZeroData extends VssComponent<IDRIToolsZeroData> {
    private imageUrl: string;

    constructor(props: IDRIToolsZeroData, context: IVssComponentContext) {
        super(props);

        this.imageUrl = getAssetLocation(context.pageContext, "ms.vss-dri-tools-web/dri-tools-core-content/Content/no-results.png");
    }

    public render(): JSX.Element {
        return (
            <div className="zero-data-container flex-grow">
                {this.props.isInvalid ?
                    <div className="font-size-m flex-row justify-center">
                        {Resources.Callgraph_Error_InvalidId}
                    </div> :
                    <ZeroData
                        imageAltText={Resources.Callgraph_Error_EmptyRequest}
                        imagePath={this.imageUrl}
                        secondaryText={Resources.Callgraph_Error_EmptyRequest}
                    />
                }
            </div>
        );
    }
}
